"use client";

import { useCities } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import type { Kh_Cities } from "@sisnaker-react-core/karirhub-model-type";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface CityComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
  provinceIds?: string[];
}

export const CityCombobox = ({ initialValue, onChange, onClear, disabled, provinceIds }: CityComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { cities, isLoading } = useCities({ keyword, provinceIds, enabled: !disabled, page: 1, limit: 5 });

  const options: ComboboxOption[] = cities.map((city: Kh_Cities) => ({
    value: city.id,
    label: city.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih kabupaten/kota"
      searchPlaceholder="Cari kabupaten/kota..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
